import React from 'react';
import './Card.css';

const Card = ({ children, title }) => {
  return (
    <div className="card">
      {title && <div className="card-header"><h2>{title}</h2></div>}
      <div className="card-body">
        {children}
      </div>
    </div>
  );
};

export default Card;